import React, { Component } from 'react';

import language from '../../../assets/languages/language';
import AppRoutes from '../../config/AppRoutes';
import Chapter from '../Chapter';
import Header from '../Header';
import { fetchLastAnsweredQuestion } from '../services';
import { messages } from '../../../common/messages';
import { EXAM_NAMES } from '../../../common/constant';
import QuestionModeSetting from '../../../Components-2025/QuestionModeSetting';

export class ESGQuestionBank extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      chapterId: '',
      questionId: '',
    };
  }
  getLastAnsweredQuestion = async () => {
    const result = await fetchLastAnsweredQuestion();
    if (result.success) {
      return result.getLastAnsweredQuestion;
    }
    return {};
  };

  componentDidMount = async () => {
    const result = await this.getLastAnsweredQuestion();
    const { chapter_id, question_id } = result;
    this.setState({ chapterId: chapter_id, questionId: question_id });
  };

  redirectToQuestionBank = ({ questionId, chapterId }) => {
    this.context.router.push({
      pathname: AppRoutes.ESG_QUESTION_BANK_VIEW_QUE.replace(':chapterId', chapterId).replace(
        ':id',
        questionId,
      ),
    });
  };

  render() {
    const { questionId, chapterId } = this.state;

    return (
      <div className='animated fadeIn'>
        <Header title={language.LC().QUESTION_BANK}>
          <QuestionModeSetting examNameKey={EXAM_NAMES.ESG} />
          <button
            className='btn btn-primary pointer_class'
            onClick={() => this.redirectToQuestionBank({ questionId, chapterId })}
            disabled={!questionId}
          >
          {messages.GO_TO_MY_LAST_QUESTION_ANSWERED}
          </button>
        </Header>
        <Chapter
          headerImage={'/img/question_bank/icon2.svg'}
          apiEndpoint={'/esg/chapter'}
          imageWidth={54}
          // redirectRoute={AppRoutes.ESG_QUESTION_BANK_VIEW_QUE}
          redirectRoute={AppRoutes.ESG_QUESTION_BANK_LIST_QUE}
        />
      </div>
    );
  }
}

export default ESGQuestionBank;



// WEBPACK FOOTER //
// ./src/views/ESG/QuestionBank/index.jsx